var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"mx-auto pa-6 py-10 px-6 rounded-xl elevation-6 submited"},[_c('h3',[_vm._v(" Thank you for your request. We will contact you by telephone as soon as possible to inform you about how you can best save! ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }